<template>
  <div uk-grid class="uk-grid-small uk-text-center">
    <div class="uk-width-1-1 loading-spinner" uk-spinner="ratio: 1"></div>
    <div class="uk-width-1-1 loading-message uk-text-bold">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoadingSpinner",
  data() {
    return {};
  }
};
</script>

<style lang="less" scoped>
@import "../styles/variables.less";

.loading-spinner.uk-icon,
.loading-message {
  color: @color-synergy-red;
}
</style>
